var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"ma-2",attrs:{"row":""}},[_c('v-flex',{attrs:{"md8":""}},[_c('v-card',{attrs:{"tile":"","loading":_vm.loading_data}},[_vm._t("default"),(_vm.$slots.actions)?_c('v-card-actions',[_c('v-spacer'),_vm._t("actions")],2):_vm._e()],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }